var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',{staticClass:"v-ext-input-fallback",attrs:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event);}}})}
var staticRenderFns = []

export { render, staticRenderFns }